<div class="row">
  <div class="col-6 col-md-3">
    <mat-form-field
      class="light-form-field time-selection availability-filter-picker">
      <mat-label>{{
        ("employmentDuration" | i18n) || "Einsatzdauer" | titlecase
      }}</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input
          matStartDate
          name="fromDate"
          [ngModel]="managementService.fromParamDate$ | async"
          (ngModelChange)="prepareFromDate($event)"
          (click)="picker.open()" />
        <input
          matEndDate
          name="toDate"
          [ngModel]="managementService.toParamDate$ | async"
          (ngModelChange)="updateToParam($event)"
          (click)="picker.open()" />
      </mat-date-range-input>
      <mat-icon
        *ngIf="
          (managementService.fromParamDate$ | async) &&
          (managementService.toParamDate$ | async)
        "
        svgIcon="close"
        class="clear-date-icon"
        (click)="clearDates(); $event.stopPropagation()"></mat-icon>
      <mat-datepicker-toggle
        matSuffix
        [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </div>

  <app-department-select
    class="col col-6 col-md-3 light-form-field"
    [autoSelectOnlyDepartment]="true"
    [useQueryParam]="'department'"></app-department-select>
  <app-certificate-select
    class="col-6 col-md-3 light-form-field"
    [useQueryParam]="'certificates'"></app-certificate-select>
  <div class="col-6 col-md-3">
    <mat-form-field class="light-form-field">
      <mat-label>{{ ("search" | i18n) || "Suchen..." | titlecase }}</mat-label>
      <input
        matInput
        [ngModel]="managementService.searchParam$ | async"
        (ngModelChange)="updateQueryParams({ searchText: $event })"
        name="searchText"
        data-cy="employment-search-input" />
    </mat-form-field>
  </div>
</div>
